module.exports = __webpack_public_path__ + "static/Calluna-Light-webfont-6d275187d8b9dabf581e94c46d337871.woff";